module.exports = __webpack_public_path__ + "static/media/logo_drafts.3d11fe9c.png";